import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const OMNIBOX_ANALYTICS_ACTIONS = {
  OPENED_OMNIBOX: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'opened_omnibox',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_RESULT: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'clicked_omnibox_result',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_QUERY: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'submitted_omnibox_query',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_QUICK_ACTION: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'clicked_omnibox_quick_action',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_FILTER: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'added_omnibox_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REMOVED_FILTER: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'removed_omnibox_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_OMNIBOX: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'closed_omnibox',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DISPLAYED_RESULTS: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'displayed_omnibox_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
